<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="ded">
<p class="ct"><a class="xref" href="#/OEBPS/pppvalentinemurder005#toc">Dedication</a></p>
<p class="ded"><i class="calibre4">To Jack and Marie Mattock</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-valentinemurder004.vue?2991ea52